<script setup>
definePage({
  meta: {
    action: 'write',
    subject: 'source-site',
    navActiveLink: 'sources-sites',
  },
})

import { type } from '@/datas/sites'
import { getProjectId } from "@/utils/cdms"
import { useSnackBar } from '@/utils/stores/snackbar'
import SearchSiteDialog from '@/views/sources/sites/searchSiteDialog.vue'

const router = useRouter()
const snackbarStore = useSnackBar()
const showSearchDialog = ref(false)
if(await isLockedProject()) {router.back()}

const data = reactive({
  projectId: getProjectId(),
  siteId: "",
  contractDate: "",
})

const refForm = ref(null)

const typeRadios = type

const searchSite = () => {
  showSearchDialog.value = true
}

const selectSite = site => {
  data.siteId = site.id
  data.name = site.name
  data.phone = site.phone
  data.type = site.type
  data.address = site.address
  data.investigator = site.investigator
}

const saveSite = async () => {
  const validate = await refForm?.value.validate()
  if(!validate.valid) return

  const result = await $api(`/sources/sites`, { method: 'POST',
    body: { site: data } })

  snackbarStore.showSnackBar("Successfully Saved!")

  router.push({ name: `sources-sites` })
}
</script>

<template>
  <SearchSiteDialog
    :show="showSearchDialog"
    @update:show="showSearchDialog=false"
    @select-item="selectSite"
  />
  <VRow>
    <VCol
      cols="12"
      sm="12"
      md="9"
      lg="7"
      order="1"
      order-lg="1"
    >
      <VCard title="기관 등록">
        <!-- <VCardTitle></VCardTitle> -->
        <VCardText class="mt-4">
          <VForm
            ref="refForm"
            @submit.prevent="() => {}"
          >
            <VRow>
              <VCol cols="12">
                <VRow no-gutters>
                  <!-- 👉 Site Name -->
                  <VCol
                    cols="12"
                    md="3"
                    class="d-flex align-items-center"
                  >
                    <label
                      class="v-label text-body-2 text-high-emphasis"
                      for="name"
                    >{{ $t('Site Name') }}<span style="color:red">*</span></label>
                  </VCol>

                  <VCol
                    cols="12"
                    md="9"
                  >
                    <AppTextField
                      id="name"
                      v-model="data.name"
                      persistent-placeholder
                      :rules="[requiredValidator]"
                      readonly
                    >
                      <template #append>
                        <VBtn @click="searchSite">
                          {{ $t('Search') }}
                        </VBtn>
                      </template>
                    </AppTextField>
                  </VCol>
                </VRow>
              </VCol>
              <VCol cols="12">
                <VRow no-gutters>
                  <!-- 👉 Site Phone -->
                  <VCol
                    cols="12"
                    md="3"
                    class="d-flex align-items-center"
                  >
                    <label
                      class="v-label text-body-2 text-high-emphasis"
                      for="phone"
                    >{{ $t('Phone') }}<span style="color:red">*</span></label>
                  </VCol>

                  <VCol
                    cols="12"
                    md="9"
                  >
                    <AppTextField
                      id="phone"
                      v-model="data.phone"
                      persistent-placeholder
                      :rules="[requiredValidator]"
                      disabled
                    />
                  </VCol>
                </VRow>
              </VCol>
              <VCol cols="12">
                <VRow no-gutters>
                  <!-- 👉 Type -->
                  <VCol
                    cols="12"
                    md="3"
                    class="d-flex align-items-center"
                  >
                    <label
                      class="v-label text-body-2 text-high-emphasis"
                      for="type"
                    >{{ $t('Type') }}<span style="color:red">*</span></label>
                  </VCol>

                  <VCol
                    cols="12"
                    md="9"
                  >
                    <VRadioGroup v-model="data.type">
                      <VRadio
                        v-for="(item, index) in typeRadios"
                        :key="index"
                        :value="item.value"
                        :label="$t(item.text)"
                        density="compact"
                        disabled
                      />
                    </VRadioGroup>
                  </VCol>
                </VRow>
              </VCol>
              <VCol cols="12">
                <VRow no-gutters>
                  <!-- 👉 Address -->
                  <VCol
                    cols="12"
                    md="3"
                    class="d-flex align-items-center"
                  >
                    <label
                      class="v-label text-body-2 text-high-emphasis"
                      for="address"
                    >{{ $t('Address') }}<span style="color:red">*</span></label>
                  </VCol>

                  <VCol
                    cols="12"
                    md="9"
                  >
                    <AppTextField
                      id="address"
                      v-model="data.address"
                      persistent-placeholder
                      :rules="[requiredValidator]"
                      disabled
                    />
                  </VCol>
                </VRow>
              </VCol>
              <VCol cols="12">
                <VRow no-gutters>
                  <!-- 👉 Investigator -->
                  <VCol
                    cols="12"
                    md="3"
                    class="d-flex align-items-center"
                  >
                    <label
                      class="v-label text-body-2 text-high-emphasis"
                      for="investigator"
                    >{{ $t('Investigator') }}<span style="color:red">*</span></label>
                  </VCol>

                  <VCol
                    cols="12"
                    md="9"
                  >
                    <AppTextField
                      id="investigator"
                      v-model="data.investigator"
                      persistent-placeholder
                      :rules="[requiredValidator]"
                      disabled
                    />
                  </VCol>
                </VRow>
              </VCol>
              <VCol cols="12">
                <VRow no-gutters>
                  <!-- 👉 Contract Date -->
                  <VCol
                    cols="12"
                    md="3"
                    class="d-flex align-items-center"
                  >
                    <label
                      class="v-label text-body-2 text-high-emphasis"
                      for="contractDate"
                    >{{ $t('Contract date') }}<span style="color:red">*</span></label>
                  </VCol>

                  <VCol
                    cols="12"
                    md="9"
                  >
                    <AppDateTimePicker
                      v-model="data.contractDate"
                      append-inner-icon="tabler-calendar-event"
                      :rules="[requiredValidator]"
                    />
                  </VCol>
                </VRow>
              </VCol>
              <!-- 👉 submit and reset button -->
              <VCol
                offset-md="3"
                cols="12"
                md="9"
                class="d-flex gap-4"
              >
                <VBtn
                  type="submit"
                  @click="saveSite"
                >
                  {{ $t('Save') }}
                </VBtn>
                <VBtn
                  color="secondary"
                  variant="tonal"
                  @click="$router.back()"
                >
                  {{ $t('Cancel') }}
                </VBtn>
              </VCol>
            </VRow>
          </VForm>
        </VCardText>
      </vcard>
    </VCol>
  </VRow>
</template>
